import React, { useState, useEffect  } from 'react';
import {   Badge,  IconButton, Card, CardHeader,  Grid, Typography, alpha, useTheme} from '@mui/material';
import { useApi } from '../../hooks/useApi'
import { Link } from 'react-router-dom'; // Import Link from React Router
import SpeakerImage from '../../media/Lamp Poses-01-1.png'

function TileAssessments ({ account }) {

    const jApi = useApi();
    const theme = useTheme();
    const [errorMessage, setErrorMessage] = useState(null)
    
    const fetchData = (async () => {
        try {
            setErrorMessage("")

        } catch (ex) {
            setErrorMessage(ex.toString());
        } finally {
        }
    });

    useEffect(() => {
        fetchData(); 
    }, [account]); 
      
    return(
        <>
            <Card
              elevation={0}
              sx={{
                background: theme.palette.mode === 'dark'
                  ? alpha(theme.palette.background.paper, 0.8)
                  : alpha(theme.palette.background.paper, 0.95),
                backdropFilter: 'blur(20px)',
                border: `1px solid ${alpha(theme.palette.divider, theme.palette.mode === 'dark' ? 0.1 : 0.2)}`,
                borderRadius: 3,
                boxShadow: theme.palette.mode === 'dark'
                  ? `0 4px 12px ${alpha(theme.palette.common.black, 0.3)}`
                  : `0 2px 8px ${alpha(theme.palette.common.black, 0.08)}`,
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: `0 12px 24px ${alpha(theme.palette.primary.main, 0.15)}`,
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                },
              }}
            >
                <CardHeader  component={Link} to="/assessment" sx={{textDecoration: 'none'}}
                    avatar={

                    <IconButton edge="end" color="inherit" aria-label="logo" disableFocusRipple={true} disableRipple>
                    <img
                        width="70"
                        height="70"
                        src={SpeakerImage}
                        alt="Logo"
                    />
                    </IconButton>
                    }
                    title={

                        <Typography component="h6" variant="h6" sx={{textDecoration: 'none', color: (theme) => theme.palette.secondary.main}}>
                            Assessment Center
                        </Typography>
                        
                    }
                    subheader="Assess the security of your Microsoft 365 environment."

                />
            </Card>



            <Grid item sm={12}>
                <Typography  variant="subheading1" color="error" > {errorMessage}</Typography>
            </Grid> 

        </>
    )

}

export default TileAssessments
